<template>
  <section :class="['box', containerClass]">
    <h3>{{ title }}</h3>

    <template v-if="hasUsers">
      <winners-user-list-item
        v-for="(user, index) in __userList"
        :key="user.msisdn"
        :user="user"
        :animated="index >= initialTotalMaxUsersRendered"
      ></winners-user-list-item>

      <a v-if="hasMoreUsersToLoad" href="#" class="load-more" @click.prevent="handleLoadMoreUsers">···</a>
    </template>

    <template v-else>
      <p class="no_win">{{ getTranslations.winners_page_no_winners }}</p>
    </template>

    <p class="next_win">
      {{ getTranslations.winners_page_next_win_pt1_description }}
      <b>{{ nextWinDate }}</b>
    </p>

    <p class="last_upd">
      {{ getTranslations.winners_page_last_updated }}:
      <b>{{ lastUpdateDate | formatDateFilter }}</b>
    </p>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import WinnersUserListItem from './WinnersUserListItem'

export default {
  name: 'WinnersPrizeListItem',
  components: {WinnersUserListItem},
  props: {
    type: {
      type: String,
      default: 'GRAND_PRIZE'
    },
    userList: {
      type: Array,
      default: () => []
    },
    lastUpdateDate: {
      type: [String, Number, Date],
      default: ''
    },
    containerClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  filters: {
    formatDateFilter: date => {
      if (date) {
        moment.locale(localStorage.getItem('locale'))
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      initialTotalMaxUsersRendered: 2,
      isAllUserListExpanded: false
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    title () {
      return this.getTranslations[`winners_page_prize_${this.type}`] || ''
    },
    nextWinDate () {
      return this.getTranslations[`winners_page_next_win_pt2_date_${this.type}`] || '-'
    },
    totalUsers () {
      return this.userList.length
    },
    hasUsers () {
      return this.totalUsers > 0
    },
    hasMoreUsersToLoad () {
      return (this.totalUsers > this.initialTotalMaxUsersRendered) && !this.isAllUserListExpanded
    },
    __userList () {
      return this.isAllUserListExpanded
        ? this.userList
        : this.userList.slice(0, this.initialTotalMaxUsersRendered)
    }
  },
  methods: {
    handleLoadMoreUsers () {
      this.isAllUserListExpanded = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WinnersPrizeListItem.vue